import React, { useEffect } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { useHistory } from "react-router-dom";

function GenericHome() {
    const history = useHistory();

    function handleRedirect() {
        var redirectPath = '/' + sessionStorage.getItem('Role') + 'Home';
        history.push(redirectPath);
    }

    useEffect(() => {
        handleRedirect();
    }, []);

    return (
        <div>

        </div>

    );
}

export default GenericHome;
